import { render } from "./BusinessIntelligence.vue?vue&type=template&id=1a98f9cd&scoped=true&ts=true"
import script from "./BusinessIntelligence.vue?vue&type=script&lang=ts"
export * from "./BusinessIntelligence.vue?vue&type=script&lang=ts"

import "./BusinessIntelligence.vue?vue&type=style&index=0&id=1a98f9cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a98f9cd"]])

export default __exports__